import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ReviewersDetailModal from "./ReviwersDetailView";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";

// const BASE_URL = "http://localhost:8000"; // replace with your API base URL if needed

const AppraisalHistoryViewModal = ({ show, handleClose, selectedEmployee }) => {
  const gridRef = useRef(null);
  const [gridHeight, setGridHeight] = useState(400);
  const [reviewersModalOpen, setReviewersModalOpen] = useState(false);
const [selectedReviewers, setSelectedReviewers] = useState([]);
const modalRef = useRef(null);

  useEffect(() => {
    const calculateHeight = () => {
      const windowHeight = window.innerHeight;
      const offset = 200;
      const calculatedHeight = windowHeight - offset;
      setGridHeight(calculatedHeight);
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    return () => window.removeEventListener("resize", calculateHeight);
  }, []);

  if (!selectedEmployee) return null;
  

  const columnDefs = [
    { headerName: "SR No", valueGetter: (params) => params.node.rowIndex + 1, maxWidth: 80 },
    { headerName: "Cycle Start", field: "cycle_start", flex: 1 },
    { headerName: "Cycle End", field: "cycle_end", flex: 1 },
    { headerName: "Old Salary", field: "old_salary", flex: 1 },
    { headerName: "Hike %", field: "hike_percentage", flex: 1 },
    { headerName: "New Salary", field: "new_salary", flex: 1 },
    { headerName: "Effective From", field: "effective_from", flex: 1 },
    { headerName: "Review Count", field: "review_count", flex: 1 },
    {
      headerName: "Review Detail",
      field: "reviewers_details",
      flex: 1,
      cellRenderer: (params) => (
        <Tooltip title="View Review Details">
          <IconButton
            size="small"
           onClick={() => {
  setSelectedReviewers(params.data.reviewers_details || []);
  setReviewersModalOpen(true);
}}

          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  
  return (
    <Dialog
          open={show}
          onClose={handleClose}
          
          maxWidth="md"
          fullWidth
          PaperProps={{
            ref: modalRef,
            sx: {
              height: "100vh",
              width: "100vw",
              maxWidth: "none",
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
      <DialogTitle sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 2,
            borderBottom: "1px solid #ccc",
          }}
        >
          {selectedEmployee?.profile_image ? (
           <ProtectedImage
  path={
    selectedEmployee.profile_image.startsWith("data:")
      ? selectedEmployee.profile_image
      : `${IMAGE_URL}${selectedEmployee.profile_image}`
  }
  alt="Profile"
  style={{
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    objectFit: "cover"
  }}
/>

          ) : (
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: "bold",
                fontSize: 20,
                textTransform: "uppercase",
              }}
            >
              {selectedEmployee?.employee_name?.split(" ")[0]?.[0]}
              {selectedEmployee?.employee_name?.split(" ")[1]?.[0]}
            </Box>
          )}

          <Box sx={{ ml: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              <Typography variant="h6" fontWeight="bold">
                {selectedEmployee?.employee_name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                ({selectedEmployee?.employee_id || "N/A"})
              </Typography>
              <Box
                              sx={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: selectedEmployee?.is_active ? "#00cc00" : "red",
                                ml: 0.5,
                              }}
                            />
            </Box>
            
            <Typography variant="body2" color="text.secondary">
              {selectedEmployee?.designation || "N/A"}
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
  <Box
    className="list-grid-container"
    sx={{
      width: "100%",
      mt: 2,          // top margin
      overflow: "hidden" // prevents extra outer scroll
    }}
  >
    <ReusableGrid
      rowData={selectedEmployee?.history || []}
      columnDefs={columnDefs}
       gridRef={gridRef}
          domLayout="normal" 
            height={`${gridHeight}px`}
      pagination={false}  // ✅ remove paginationdomLayout="normal"  // ✅ allow internal scroll
    />
  </Box>
  

</DialogContent>
  <div>
    <ReviewersDetailModal
  open={reviewersModalOpen}
  handleClose={() => setReviewersModalOpen(false)}
  reviewers={selectedReviewers}
  anchorEl={modalRef.current}
/>

  </div>

    </Dialog>
  );
};

export default AppraisalHistoryViewModal;
